import * as yup from 'yup';

const NurseVisitSchema = yup.object({
  participant: yup.string().nullable(),
  creationDate: yup.date().nullable(),
  risks: yup.boolean().nullable(),
  risksRemark: yup.string().nullable(),
  monitoring: yup.boolean().nullable(),
  monitoringRemark: yup.string().nullable(),
  integrationInterview: yup.boolean().nullable(),
  integrationInterviewRemark: yup.string().nullable(),
  medicalCommunicationUnderstandability: yup.boolean().nullable(),
  medicalCommunicationUnderstandabilityRemark: yup.string().nullable(),
  treatmentCareOrder: yup.boolean().nullable(),
  treatmentCareOrderRemark: yup.string().nullable(),
  medicationSupplyOrder: yup.boolean().nullable(),
  medicationSupplyOrderRemark: yup.string().nullable(),
  pain: yup.boolean().nullable(),
  painAssessment: yup.boolean().nullable(),
  painAssessmentRemark: yup.string().nullable(),
  medicalCommunicationNecessity: yup.boolean().nullable(),
  medicalCommunicationNecessityRemark: yup.string().nullable(),
  chronicWounds: yup.boolean().nullable(),
  woundDescription: yup.boolean().nullable(),
  woundDescriptionRemark: yup.string().nullable(),
  woundTherapy: yup.boolean().nullable(),
  woundTherapyRemark: yup.string().nullable(),
  woundVisit: yup.boolean().nullable(),
  woundVisitRemark: yup.string().nullable(),
  fallRiskRecord: yup.boolean().nullable(),
  fallRiskRecordRemark: yup.string().nullable(),
  fallRisk: yup.boolean().nullable(),
  fallRiskMeasures: yup.boolean().nullable(),
  fallRiskMeasuresRemark: yup.string().nullable(),
  fallRiskDocumentation: yup.boolean().nullable(),
  fallRiskDocumentationRemark: yup.string().nullable(),
  ulcerRiskRecord: yup.boolean().nullable(),
  ulcerRiskRecordRemark: yup.string().nullable(),
  ulcerRisk: yup.boolean().nullable(),
  ulcerRiskMeasures: yup.boolean().nullable(),
  ulcerRiskMeasuresRemark: yup.string().nullable(),
  contractureRiskRecord: yup.boolean().nullable(),
  contractureRiskRecordRemark: yup.string().nullable(),
  contractureRisk: yup.boolean().nullable(),
  contractureRiskMeasures: yup.boolean().nullable(),
  contractureRiskMeasuresRemark: yup.string().nullable(),
  nutritionRiskRecord: yup.boolean().nullable(),
  nutritionRiskRecordRemark: yup.string().nullable(),
  nutritionRisk: yup.boolean().nullable(),
  nutritionRiskMeasures: yup.boolean().nullable(),
  nutritionRiskMeasuresRemark: yup.string().nullable(),
  fluidSupplyRiskRecord: yup.boolean().nullable(),
  fluidSupplyRiskRecordRemark: yup.string().nullable(),
  fluidSupplyRisk: yup.boolean().nullable(),
  fluidSupplyMeasures: yup.boolean().nullable(),
  fluidSupplyMeasuresRemark: yup.string().nullable(),
  urineStoolContinenceRiskRecord: yup.boolean().nullable(),
  urineStoolContinenceRiskRecordRemark: yup.string().nullable(),
  urineStoolContinenceRisk: yup.boolean().nullable(),
  urineStoolContinenceMeasures: yup.boolean().nullable(),
  urineStoolContinenceMeasuresRemark: yup.string().nullable(),
  personalCareAbnormalities: yup.boolean().nullable(),
  personalCareAbnormalitiesRemark: yup.string().nullable(),
  personalCareRiskRecord: yup.boolean().nullable(),
  personalCareRiskRecordRemark: yup.string().nullable(),
  personalCareRisk: yup.boolean().nullable(),
  personalCareRiskMeasures: yup.boolean().nullable(),
  personalCareRiskMeasuresRemark: yup.string().nullable(),
  visionHearingRiskRecord: yup.boolean().nullable(),
  visionHearingRiskRecordRemark: yup.string().nullable(),
  visionHearingRisk: yup.boolean().nullable(),
  visionHearingRiskMeasures: yup.boolean().nullable(),
  visionHearingRiskMeasuresRemark: yup.string().nullable(),
  outdoorStay: yup.boolean().nullable(),
  outdoorStayRemark: yup.string().nullable(),
  challengingBehavior: yup.boolean().nullable(),
  challengingBehaviorRecord: yup.boolean().nullable(),
  challengingBehaviorRecordRemark: yup.string().nullable(),
  challengingBehaviorMeasures: yup.boolean().nullable(),
  challengingBehaviorMeasuresRemark: yup.string().nullable(),
  freedomRestrictMeasures: yup.boolean().nullable(),
  freedomRestrictCorrectness: yup.boolean().nullable(),
  freedomRestrictCorrectnessRemark: yup.string().nullable(),
  biography: yup.boolean().nullable(),
  biographyRemark: yup.string().nullable(),
  everydayLifeRiskRecord: yup.boolean().nullable(),
  everydayLifeRiskRecordRemark: yup.string().nullable(),
  everydayLifeRisk: yup.boolean().nullable(),
  biographyMeasures: yup.boolean().nullable(),
  biographyMeasuresRemark: yup.string().nullable(),
  wellBeingDocumentation: yup.boolean().nullable(),
  wellBeingDocumentationRemark: yup.string().nullable(),
  dueDate: yup.date().nullable(),
  filledOutAt: yup.date().nullable(),
  filledOutAtRemark: yup.string().nullable(),
  checkedAt: yup.date().nullable(),
  checkedAtRemark: yup.string().nullable(),
});

export const CreateNurseVisitSchema = NurseVisitSchema.concat(
  yup.object({
    residentId: yup.string().notRequired(),
  }),
);

export interface INurseVisit {
  participant?: string;
  creationDate?: Date;
  risksyup?: boolean;
  risksRemark?: string;
  monitoring?: boolean;
  monitoringRemark?: string;
  integrationInterview?: boolean;
  integrationInterviewRemark?: string;
  medicalCommunicationUnderstandability?: boolean;
  medicalCommunicationUnderstandabilityRemark?: string;
  treatmentCareOrder?: boolean;
  treatmentCareOrderRemark?: string;
  medicationSupplyOrder?: boolean;
  medicationSupplyOrderRemark?: string;
  pain?: boolean;
  painAssessment?: boolean;
  painAssessmentRemark?: string;
  medicalCommunicationNecessity?: boolean;
  medicalCommunicationNecessityRemark?: string;
  chronicWounds?: boolean;
  woundDescription?: boolean;
  woundDescriptionRemark?: string;
  woundTherapy?: boolean;
  woundTherapyRemark?: string;
  woundVisit?: boolean;
  woundVisitRemark?: string;
  fallRiskRecord?: boolean;
  fallRiskRecordRemark?: string;
  fallRisk?: boolean;
  fallRiskMeasures?: boolean;
  fallRiskMeasuresRemark?: string;
  fallRiskDocumentation?: boolean;
  fallRiskDocumentationRemark?: string;
  ulcerRiskRecord?: boolean;
  ulcerRiskRecordRemark?: string;
  ulcerRisk?: boolean;
  ulcerRiskMeasures?: boolean;
  ulcerRiskMeasuresRemark?: string;
  contractureRiskRecord?: boolean;
  contractureRiskRecordRemark?: string;
  contractureRisk?: boolean;
  contractureRiskMeasures?: boolean;
  contractureRiskMeasuresRemark?: string;
  nutritionRiskRecord?: boolean;
  nutritionRiskRecordRemark?: string;
  nutritionRisk?: boolean;
  nutritionRiskMeasures?: boolean;
  nutritionRiskMeasuresRemark?: string;
  fluidSupplyRiskRecord?: boolean;
  fluidSupplyRiskRecordRemark?: string;
  fluidSupplyRisk?: boolean;
  fluidSupplyMeasures?: boolean;
  fluidSupplyMeasuresRemark?: string;
  urineStoolContinenceRiskRecord?: boolean;
  urineStoolContinenceRiskRecordRemark?: string;
  urineStoolContinenceRisk?: boolean;
  urineStoolContinenceMeasures?: boolean;
  urineStoolContinenceMeasuresRemark?: string;
  personalCareAbnormalities?: boolean;
  personalCareAbnormalitiesRemark?: string;
  personalCareRiskRecord?: boolean;
  personalCareRiskRecordRemark?: string;
  personalCareRisk?: boolean;
  personalCareRiskMeasures?: boolean;
  personalCareRiskMeasuresRemark?: string;
  visionHearingRiskRecord?: boolean;
  visionHearingRiskRecordRemark?: string;
  visionHearingRisk?: boolean;
  visionHearingRiskMeasures?: boolean;
  visionHearingRiskMeasuresRemark?: string;
  outdoorStay?: boolean;
  outdoorStayRemark?: string;
  challengingBehavior?: boolean;
  challengingBehaviorRecord?: boolean;
  challengingBehaviorRecordRemark?: string;
  challengingBehaviorMeasures?: boolean;
  challengingBehaviorMeasuresRemark?: string;
  freedomRestrictMeasures?: boolean;
  freedomRestrictCorrectness?: boolean;
  freedomRestrictCorrectnessRemark?: string;
  biography?: boolean;
  biographyRemark?: string;
  everydayLifeRiskRecord?: boolean;
  everydayLifeRiskRecordRemark?: string;
  everydayLifeRisk?: boolean;
  biographyMeasures?: boolean;
  biographyMeasuresRemark?: string;
  wellBeingDocumentation?: boolean;
  wellBeingDocumentationRemark?: string;
  dueDate?: Date;
  filledOutAt?: Date;
  filledOutAtRemark?: string;
  checkedAt?: Date;
  checkedAtRemark?: string;
}

export interface ICreateNurseVisit extends INurseVisit {
  residentId: string;
}
